import _orderBy from 'lodash/orderBy';
import * as React from 'react';

export interface KeysAndDirections {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  keys?: Array<string | number | ((string) => string)>;
  directions?: Array<'asc' | 'desc' | null>;
}

/**
 * @description A hook for ordering table data in the Omics Explorer.
 */
export function useOrderByTableData(data: Array<any>) {
  const [sortKeys, setSortKeys] =
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    React.useState<KeysAndDirections['keys']>(null);
  const [sortDir, setSortDir] =
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    React.useState<KeysAndDirections['directions']>(null);
  const [sortedData, setSortedData] = React.useState<Array<any>>(data);

  const handleSortClicked = ({ keys, directions }: KeysAndDirections) => {
    setSortKeys(keys);
    setSortDir(directions);
  };

  React.useEffect(() => {
    if (sortKeys && sortDir) {
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      setSortedData(_orderBy(data, sortKeys, sortDir));
      return;
    }

    // Sort was deselected completely, so default to un-sorted data
    setSortedData(data);
  }, [data, sortDir, sortKeys]);

  return {
    handleSortClicked,
    sortedData,
  };
}
